{
  "GenericScopeTab_CME": "ECM",
  "GenericScopeTab_Telsys": "Server di telefonia",
  "GenericScopeTab_Telsys_Required": "È richiesto il server di telefonia",
  "GenericScopeTab_Partition": "Partizione",
  "GenericScopeTab_Device": "Dispositivo",
  "GenericScopeTab_FilterRecursive": "Filtra ricorsivamente",
  "NAME": "GenericScopeTab"
}